import { render, staticRenderFns } from "./MessagingComponent.vue?vue&type=template&id=676a3b02"
import script from "./MessagingComponent.vue?vue&type=script&lang=ts"
export * from "./MessagingComponent.vue?vue&type=script&lang=ts"
import style0 from "./MessagingComponent.vue?vue&type=style&index=0&id=676a3b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports